import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm, useFieldArray } from "react-hook-form";
import React, {useEffect, useState} from "react";
import OWASP from "../../../../util/owasp";


const MantUser = ( {MySwal, title, idEdit, fnReset, fnCrear, colaborador, usuario, setUsuario, setColaborador, tiposDocumento, fnBuscar, showCreate, showDelete, showReset, icon, zonas, agencias, fnActualizar, agenciasAsignadas}) => {

    const { handleSubmit, reset, register, setValue, watch, control, formState: { errors } } = useForm({mode: "onChange"});
    
    const [tipoBq, setTipoBq] = useState(CONFIGURACIONES.INIT.STRING);
    const [patronDocumento, setPatronDocumento] = useState(CONFIGURACIONES.INIT.STRING);

    // 1. Hook para manejar el array de asignaciones (la tabla)
    const { fields, append, remove } = useFieldArray({
        control,
        name: "agenciasAsignadas",
    });

    // 2. Observar los selects de zona y agencia para filtrar y habilitar el botón de agregar
    const zonaSeleccionada = watch("zonaSeleccionada"); 
    const agenciaSeleccionada = watch("agenciaSeleccionada"); 

    // 3. Función para agregar una asignación (Zona-Agencia) al array/tabla
    const fnAgregarAgencia = () => {
        // Asegurarse de que ambas selecciones estén hechas
        if (!zonaSeleccionada || !agenciaSeleccionada) return;

        // Convertir IDs a números para la búsqueda
        const zonaIdNum = parseInt(zonaSeleccionada);
        const agenciaIdNum = parseInt(agenciaSeleccionada);

        // Buscar los objetos completos para obtener sus nombres y códigos (usamos 'zonas' y 'agencias')
        const zonaObj = zonas.find(z => z.id === zonaIdNum);
        const agenciaObj = agencias.find(a => a.id === agenciaIdNum);

        if (zonaObj && agenciaObj) {
            // Verificar si la combinación Zona-Agencia ya existe en la lista
            const existe = fields.some(
                (item) => item.zonaId === zonaIdNum && item.agenciaId === agenciaIdNum
            );

            console.log('fields', fields);
            console.log('zonaId', zonaIdNum);
            console.log('agenciaId', agenciaIdNum);

            if (!existe) {
                // Agregar la nueva fila al array (useFieldArray)
                append({
                    zonaId: zonaIdNum,
                    agenciaId: agenciaIdNum,
                    zona: zonaObj.nombre,
                    agencia: agenciaObj.nombre,
                });

                // Opcional: Resetear la selección de Agencia después de agregar
                setValue("agenciaSeleccionada", "");
            } else {
                alert("Esta Zona y Agencia ya están asignadas.");
            }
        }
    };

    const onSubmit1 = (form) => {

        if (colaborador) {
            const agenciasAsignadas = watch("agenciasAsignadas");
            let data = null;
            // Enviar el array de asignaciones en lugar de los inputs simples
            if (!usuario && colaborador) {
                data = {
                    'usuarioNuevo': form.usuarioNuevo,
                    'empleadoId': colaborador.id,
                    'asignaciones': agenciasAsignadas // Se envía el array de objetos asignados
                };
                fnCrear(data);
                return;
            }

            data = {
                'usuario': usuario.usuario,
                'empleadoId': colaborador.id,
                'asignaciones': agenciasAsignadas // Se envía el array de objetos asignados
            };
            fnActualizar(data, usuario.id);
        }
    };

    const resetPassword = () => {
        if (!usuario) {
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Indique <strong>Usuario</strong>`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });

            return;
        }

        if (!colaborador) {
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Indique <strong>Colaborador</strong>`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });

            return;
        }

        let data = {
            'usuarioId': usuario.id,
            'empleadoId': colaborador.id
        };
        fnReset(data);
    }

    useEffect(() => {
        if (agenciasAsignadas && agenciasAsignadas.length > 0) {
            reset({
                agenciasAsignadas: agenciasAsignadas
            });
            setValue('zonaSeleccionada', '');
            setValue('agenciaSeleccionada', '');
        }
    }, [agenciasAsignadas, reset]);
    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="tipoBusqueda" className="control-label col-form-label">Buscar por <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoBusqueda", {
                                                required: OWASP.REQUIRED,
                                                onChange: (e) => {
                                                    setTipoBq(e.target.value);
                                                    setUsuario(CONFIGURACIONES.INIT.NULL);
                                                    setColaborador(CONFIGURACIONES.INIT.NULL);
                                                }
                                            })} className="form-control" id="tipoBusqueda" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                                
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPOS_BUSQUEDA.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoBusqueda && errors.tipoBusqueda.message }</small>
                                    </div>
                                </div>
                                
                                { tipoBq === CONFIGURACIONES.INIT.TYPE_BQ_C && (
                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="tipoDocumentoRefId" className="control-label col-form-label">Tipo de Documento <span className="text-danger">*</span></label>
                                            <select 
                                                {...register("tipoDocumentoRefId", {
                                                    required: OWASP.REQUIRED,
                                                    onChange:(e) => {
                                                        setPatronDocumento(new RegExp(e.target.value.split('@@')[1]));
                                                        setValue("tipoDocumentoId", e.target.value.split('@@')[0]);
                                                        setUsuario(CONFIGURACIONES.INIT.NULL);
                                                        setColaborador(CONFIGURACIONES.INIT.NULL);
                                                    }
                                                })} className="form-control" id="tipoDocumentoRefId" 
                                                placeholder="" defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    tiposDocumento.map((el, index) => (
                                                        <option key={index} value={`${el.id}@@${el.patron_validacion}`}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <input  
                                                {...register("tipoDocumentoId", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                id="tipoDocumentoId"
                                                type="hidden" />
                                            <small className="invalid-feedback"> { errors.tipoDocumentoId && errors.tipoDocumentoId.message }</small>
                                        </div>
                                    </div>
                                )}

                                { tipoBq === CONFIGURACIONES.INIT.TYPE_BQ_C && (
                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="numeroDocumento" className="control-label col-form-label">Documento <span className="text-danger">*</span></label>
                                            <input 
                                                {...register("numeroDocumento", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: patronDocumento,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    onChange: (e) => {
                                                        setUsuario(CONFIGURACIONES.INIT.NULL);
                                                        setColaborador(CONFIGURACIONES.INIT.NULL);
                                                    }
                                                })}
                                                type="text" className="form-control" id="numeroDocumento" placeholder="" />
                                            <small className="invalid-feedback"> { errors.numeroDocumento && errors.numeroDocumento.message }</small>
                                        </div>
                                    </div>
                                )}

                                { tipoBq === CONFIGURACIONES.INIT.TYPE_BQ_U && (
                                    <div className="col-sm-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="usuario" className="control-label col-form-label">Usuario <span className="text-danger">*</span></label>
                                            <input 
                                                {...register("usuario", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    onChange: (e) => {
                                                        setUsuario(CONFIGURACIONES.INIT.NULL);
                                                        setColaborador(CONFIGURACIONES.INIT.NULL);
                                                    }
                                                })}
                                                type="text" className="form-control" id="usuario" placeholder="" />
                                            <small className="invalid-feedback"> { errors.usuario && errors.usuario.message }</small>
                                        </div>
                                    </div>
                                )}
                                
                                <div className="col-sm-1 my-auto pt-3">
                                    <button type="button" className="btn btn-sm btn-info" onClick={fnBuscar}>
                                        <i className="mdi mdi-magnify"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="row">
                                {colaborador && <div className="col-xs-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="colaborador" className="control-label col-form-label">Apellidos y Nombres</label>
                                        <input type="text" className="form-control" id="colaborador" value={colaborador.nombreCompleto} placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} /> 

                                        {!usuario && <small className="text-danger">Colaborador no tiene usuario asignado, por favor <strong>registre.</strong> </small>}
                                    </div>
                                </div>}

                                {usuario && <div className="col-xs-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="usuario" className="control-label col-form-label">Usuario</label>
                                        <input type="text" className="form-control" id="usuario" value={usuario.usuario} placeholder="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                    </div>
                                </div>}

                                {/* Campo Usuario Nuevo (mantiene la fila de Apellidos y Nombres) */}
                                {!usuario && colaborador &&
                                    <div className="col-sm-12 col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="usuarioNuevo" className="control-label col-form-label">Usuario <span className="text-danger">*</span></label>
                                            <input 
                                                {...register("usuarioNuevo", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.USER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                })}
                                                type="text" className="form-control" id="usuarioNuevo" placeholder="" />
                                            <small className="invalid-feedback"> { errors.usuarioNuevo && errors.usuarioNuevo.message }</small>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    
                    {/* INICIO BLOQUE AVANZADO: ZONA, AGENCIAS Y TABLA DE ASIGNACIÓN */}
                    {colaborador && (
                        <div className="row mt-3 d-flex align-items-center">
                            
                            {/* COLUMNA ZONA (Lista de selección) */}
                            <div className="col-xs-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="zonaSeleccionada" className="control-label col-form-label">Zona <span className="text-danger">*</span></label>
                                    <select
                                        {...register("zonaSeleccionada")}
                                        className="form-control"
                                        id="zonaSeleccionada"
                                        multiple
                                        size="8" 
                                        style={{ height: '150px' }}
                                    >
                                        <option value="" disabled>Seleccione Zona</option>
                                        {/* Rellena con datos (de props o de ejemplo) */}
                                        {zonas.map((zona) => (
                                            <option key={zona.id} value={zona.id}>{zona.nombre}</option>
                                        ))}
                                    </select>
                                    <small className="text-danger d-block"> { errors.zonaSeleccionada && errors.zonaSeleccionada.message }</small>
                                </div>
                            </div>

                            {/* COLUMNA CENTRAL (Botones + ) */}
                            <div className="col-xs-12 col-md-1 d-flex flex-column justify-content-center align-items-center" style={{ height: '150px' }}>
                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-success waves-effect mb-2" 
                                    onClick={fnAgregarAgencia}
                                    disabled={!zonaSeleccionada || !agenciaSeleccionada} 
                                >
                                    <i className="mdi mdi-plus"></i>
                                </button>
                            </div>

                            {/* COLUMNA AGENCIA (Lista de selección) */}
                            <div className="col-xs-12 col-md-4">
                                <div className="form-group">
                                    <label htmlFor="agenciaSeleccionada" className="control-label col-form-label">Agencia <span className="text-danger">*</span></label>
                                    <select
                                        {...register("agenciaSeleccionada")}
                                        className="form-control"
                                        id="agenciaSeleccionada"
                                        multiple
                                        size="8"
                                        style={{ height: '150px' }}
                                        disabled={!zonaSeleccionada} // Deshabilitar si no hay Zona seleccionada
                                    >
                                        <option value="" disabled>Seleccione Agencia</option>
                                        {/* Filtra y rellena las agencias por la Zona seleccionada */}
                                        {agencias
                                            .filter(ag => ag.zonaId === parseInt(zonaSeleccionada))
                                            .map((agencia) => (
                                                <option key={agencia.id} value={agencia.id}>{agencia.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="text-danger d-block"> { errors.agenciaSeleccionada && errors.agenciaSeleccionada.message }</small>
                                </div>
                            </div>


                            {/* Bloque para la Tabla de Asignaciones (ocupa todo el ancho abajo) */}
                            <div className="col-xs-12 col-md-9 mt-3">
                                <h6 className="card-subtitle mb-2">Asignaciones Actuales</h6>
                                {fields.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm">
                                            <thead className="thead-light">
                                                <tr style={{backgroundColor:'#dc3545',color:'white'}}>
                                                    <th className="text-center">Zona Id</th>
                                                    <th className="text-center">Agencia Id</th>
                                                    <th className="text-center">Zona</th>
                                                    <th className="text-center">Agencia</th>
                                                    <th className="text-center">Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {fields.map((item, index) => (
                                                    <tr key={`${item.zonaId}__${item.agenciaId}`}>
                                                        <td className="text-center">{item.zonaId}</td>
                                                        <td className="text-center">{item.agenciaId}</td>
                                                        <td className="text-center">{item.zona}</td>
                                                        <td className="text-center">{item.agencia}</td>
                                                        <td className="text-center">
                                                            <WaveButton
                                                                type="button"
                                                                className="btn btn-sm btn-danger waves-effect"
                                                                onClick={() => remove(index)}
                                                            >
                                                                <i className="mdi mdi-delete"></i>
                                                            </WaveButton>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p className="text-muted">Aún no se han asignado zonas y agencias.</p>
                                )}

                                {/* Campo oculto para validar que exista al menos una asignación al guardar */}
                                <input type="hidden"
                                    {...register("agenciasAsignadas", {
                                        validate: value => fields.length > 0 || "Debe asignar al menos una Zona/Agencia."
                                    })}
                                />
                                <small className="text-danger d-block"> { errors.agenciasAsignadas && errors.agenciasAsignadas.message }</small>
                            </div>
                        </div>
                    )}
                    {/* FIN BLOQUE AVANZADO */}

                    <div className="action-form mt-3 d-flex justify-content-start">
                        {/* Bloque de botones para Usuario EXISTENTE (Eliminar, Resetear) */}
                        {usuario && (
                            <div className="form-group mb-0 text-left">
                                {showDelete && <WaveButton type="button" className="btn btn-sm btn-outline-danger waves-effect">
                                    <i className="mdi mdi-delete"></i> Eliminar Usuario
                                </WaveButton>}
                            
                                {showReset && <WaveButton type="button" className="btn btn-sm btn-info waves-effect ml-2" onClick={resetPassword}>
                                    <i className="mdi mdi-refresh"></i> Resetear Contraseña
                                </WaveButton>}
                            </div>
                        )}
                        
                        {/* Bloque de botón para Usuario NUEVO (Guardar) */}
                        {colaborador && (
                            <div className="form-group mb-0 text-left ml-2">
                                {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                                    <i className="mdi mdi-content-save-settings"></i> { (!usuario && colaborador)?'Guardar': 'Actualizar'}
                                </WaveButton>}
                            </div>
                        )}
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantUser;